import { Banner, colors } from '@everlywell/leaves';
import { GatsbyImage } from 'gatsby-plugin-image';
import React from 'react';
import ewAnalytics from 'utils/analytics';
import { ANALYTICS } from 'utils/constants/analytics';
import * as BCS from './brand-centric-styles';
import { HomepageHeroProps } from './index';
import * as S from './styles';

const trackBannerClick = () => {
  ewAnalytics.track({
    event: ANALYTICS.EVENTS.CLICKED_BUTTON,
    data: {
      label: ANALYTICS.LABELS.HOMEPAGE_HERO_BANNER,
    },
  });
};

export const BrandCentricHomepageHero = ({
  headline,
  description,
  mainCta,
  listOfContent,
  backgroundColor,
  topBanner,
  ...rest
}: HomepageHeroProps): JSX.Element => {
  const handleClick = () => {
    ewAnalytics.track({
      event: ANALYTICS.EVENTS.CLICKED_BUTTON,
      data: {
        label: ANALYTICS.LABELS.HOMEPAGE_HERO_CTA,
      },
    });
  };

  return (
    <>
      {topBanner?.text && topBanner?.link ? (
        <Banner
          text={topBanner.text}
          url={topBanner.link}
          ctaText={topBanner.ctaText}
          onClick={trackBannerClick}
        />
      ) : null}
      <BCS.Section
        backgroundColor={backgroundColor || colors.teal6}
        {...rest}
        data-testid="hero"
      >
        <BCS.ImageWrapper>
          <GatsbyImage
            image={listOfContent[0]?.image.gatsbyImageData}
            loading="eager"
            alt={listOfContent[0].image.description || 'woman with test'}
            className="is-left"
          />
        </BCS.ImageWrapper>
        <BCS.TextContainer>
          <S.HeadlineAndDescription>
            {headline ? (
              <S.Headline style={{ color: colors.white, textAlign: 'center' }}>
                {headline}
              </S.Headline>
            ) : null}
            {description ? (
              <S.Description
                style={{ color: colors.white, textAlign: 'center' }}
              >
                {description}
              </S.Description>
            ) : null}
          </S.HeadlineAndDescription>
          {mainCta ? (
            <S.MainCTA
              href={mainCta.url}
              appearance="hero"
              onClick={handleClick}
            >
              {mainCta.text}
            </S.MainCTA>
          ) : null}
        </BCS.TextContainer>
        <BCS.ImageWrapper>
          <GatsbyImage
            image={listOfContent[1]?.image.gatsbyImageData}
            loading="eager"
            alt={listOfContent[1].image.description || 'desktop kit'}
            className="is-fixed-height"
          />
        </BCS.ImageWrapper>
        <BCS.MobileImg>
          <GatsbyImage
            image={listOfContent[2]?.image.gatsbyImageData}
            loading="eager"
            alt={listOfContent[2].image.description || 'woman with test'}
          />
        </BCS.MobileImg>
      </BCS.Section>
    </>
  );
};

export default BrandCentricHomepageHero;
